import { axiosPrivate } from 'shared/api';
import { BaseService } from 'shared/services/BaseService';
import { IPurchaseRequest } from '../types';

class PurchaseRequestService extends BaseService<IPurchaseRequest> {
  constructor() {
    super('purchreqhead');
    this.canDelete = true;
  }
  canBulkDelete = true;

  preApproveRequest = async (entity: { id: number; lines: any[] }) => {
    const res = await axiosPrivate.patch(`${this.modulePrefix}/${entity.id}/pre_approve_request/`, {
      lines: entity.lines
    });
    return res.data;
  };

  approveRequest = async (
    entity: { id: number; lines: any[]; values?: Record<string, any> },
    sendEmail?: boolean,
    params: Record<string, unknown> = {}
  ) => {
    const res = await axiosPrivate.patch(
      `${this.modulePrefix}/${entity.id}/approve_request/`,
      {
        lines: entity.lines,
        ...(entity.values || {})
      },
      {
        params: {
          sendEmail,
          ...params
        }
      }
    );
    return res.data;
  };

  getOrderPreview = async (req: IPurchaseRequest) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/${req.id}/order_preview/`, req);
    return res.data['detail'];
  };

  preCompile = async () => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/pre_compile/`);
    return res.data;
  };

  getEmailList = async (id: number) => {
    const res = await axiosPrivate.get(`${this.modulePrefix}/${id}/get_email_list/`);
    return res.data;
  };
}

export const purchaseRequestService = new PurchaseRequestService();
